import { DataBean } from "../DataBean";

export class ImpFreightRate extends DataBean {




    public async importFreightRate(idPriceList: any, idCurrency: any, filename: any, directory: any, dataStore: any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "java.util.List_importFreightRate_Number_Number_String_String_String", [idPriceList, idCurrency, filename, directory, dataStore]);
    }

}